import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { Box, RaiseColors, makeStyles } from "client/componentLibrary";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ProgressPills(_ref) {
  var _context;
  var currentStep = _ref.currentStep,
    numSteps = _ref.numSteps,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size;
  var pillHeight = {
    small: 3,
    medium: 8
  };
  if (currentStep < 0) {
    console.error("Expecting a positive currentStep value");
  }
  var classes = makeStyles({
    pillContainer: {
      display: "flex",
      justifyContent: "space-between"
    },
    pill: {
      height: pillHeight[size],
      backgroundColor: RaiseColors.blue500,
      opacity: 0.2,
      borderRadius: 20,
      marginRight: 4,
      flex: "2 1 auto",
      "&:last-child": {
        marginRight: 0
      }
    },
    filledPill: {
      opacity: 1
    }
  })();
  if (numSteps <= 0) {
    console.error("Expecting a positive numStep value");
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    className: classes.pillContainer,
    "data-testid": "progress-pill-container",
    children: _mapInstanceProperty(_context = _toConsumableArray(Array(numSteps))).call(_context, function (_, idx) {
      return /*#__PURE__*/_jsx(Box, {
        className: classnames(classes.pill, _defineProperty({}, classes.filledPill, idx < currentStep)),
        "data-testid": "progress-pill"
      }, idx);
    })
  });
}